import React from 'react';
import PropTypes from 'prop-types';

import { Box, Body } from '@nerdwallet/currency';
import Expandable from './company-people-expandable';

const CompanyPeopleTile = ({
  blurb,
  description,
  experience,
  featuredIn,
  imageAlt,
  imageMobile,
  isSpecialist,
  linkedInLink,
  name,
  specialties,
  title,
  twitterLink,
}) => {
  const expandedBioSection = (
    <Box paddingTop="3">
      {description && <Body size="normal">{description}</Body>}
    </Box>
  );

  const expandableContent = {
    blurb,
    copy: [expandedBioSection],
    experience,
    featuredIn,
    imageAlt,
    imageMobile,
    isSpecialist,
    jobTitle: title,
    linkedInLink,
    title: name,
    twitterLink,
    specialties,
  };

  return <Expandable {...expandableContent} />;
};

CompanyPeopleTile.propTypes = {
  blurb: PropTypes.string,
  description: PropTypes.string,
  experience: PropTypes.string,
  featuredIn: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  imageMobile: PropTypes.string,
  isSpecialist: PropTypes.bool,
  linkedInLink: PropTypes.string,
  name: PropTypes.string,
  specialties: PropTypes.string,
  title: PropTypes.string,
  twitterLink: PropTypes.string,
};

CompanyPeopleTile.displayName = 'CompanyPeopleTile';

export default CompanyPeopleTile;
